module.exports = __webpack_public_path__ + "media/application/images/ui/endorsement_peoples-choice-270ee3126bd1f770c69ae1e7ee703cd8.png";